import { useDispatch, useSelector } from "react-redux";
import { selectUIStates, selectUser, setUIStates } from "../../../../redux/features/appData";
import { useEffect } from "react";

type AppBenefitsProps = {

}

export const AppBenefits = ({} : AppBenefitsProps) => {

    const storeUser = useSelector(selectUser);
    const uiStates = useSelector(selectUIStates);
    const dispatch = useDispatch();
    
    
    useEffect(() => {
        dispatch(setUIStates({...uiStates, hrisLocation: "Benefits"}));
    }, []);

    return (
        <div>
            <h1>Benefits</h1>

            Coming soon...
        </div>
    )
}